import React from 'react';
import service from "../../../service/service";
import DownloadReport from "../DownloadReport";

export default function CloudWatchDownloadReport() {
    const apiCallFunction = service.monitoring().downLoadCloudWatchReport
    return <DownloadReport downloadFunction={apiCallFunction} title={'Cloudwatch log report'}/>
}